import { formatToman } from '@saay/formatting';
import { cn } from '@saay/shadcn/lib/utils';

const SIZE = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-2xl',
  xl: 'text-[32px] leading-none',
} as const;

/**
 * A server amount (integer rials) in toman: the figure bold with tabular digits, «تومان» smaller and
 * muted. Never re-rounds; the formatting comes from @saay/formatting.
 */
export function Money({
  rials,
  size = 'md',
  className,
}: {
  readonly rials: number;
  readonly size?: keyof typeof SIZE;
  readonly className?: string;
}) {
  const text = formatToman(rials);
  const unitAt = text.lastIndexOf(' ');
  const figure = unitAt === -1 ? text : text.slice(0, unitAt);
  const unit = unitAt === -1 ? '' : text.slice(unitAt + 1);
  return (
    <span className={cn('font-extrabold tabular-nums', SIZE[size], className)}>
      {figure}
      {unit === '' ? null : (
        <span className="ms-1 text-[max(0.5em,0.6875rem)] font-medium text-muted-foreground">
          {unit}
        </span>
      )}
    </span>
  );
}
